import { render, staticRenderFns } from "./ToggleSettingsBox.vue?vue&type=template&id=3047e648"
import script from "./ToggleSettingsBox.vue?vue&type=script&lang=js"
export * from "./ToggleSettingsBox.vue?vue&type=script&lang=js"
import style0 from "./ToggleSettingsBox.vue?vue&type=style&index=0&id=3047e648&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports